import React, { useEffect, useContext } from 'react';
import { AppSettings } from './../../config/app-settings.js';

function ExtraErrorOutside() {
  
  const context = useContext(AppSettings);
  
  useEffect(() => {
    context.handleSetAppSidebarNone(true);
    context.handleSetAppHeaderNone(true);
    context.handleSetAppContentClass('p-0');
    context.handleSetThemePanelNone(true);

    return () => {
      context.handleSetAppSidebarNone(false);
      context.handleSetAppHeaderNone(false);
      context.handleSetAppContentClass('');
      context.handleSetThemePanelNone(false);

    };
    
    // eslint-disable-next-line
  }, []);

  return (
    <div style={{ 
      backgroundColor: 'white', 
      fontFamily: 'Times New Roman, serif',
      height: '100vh',
      width: '100%',
      padding: '8px',
      display: 'block'
    }}>
      <h1 style={{ 
        display: 'block',
        fontSize: '32px',
        marginBlockStart: '0.67em',
        marginBlockEnd: '0.67em',
        marginInlineStart: '0px',
        marginInlineEnd: '0px',
        fontWeight: 'bold',
        unicodeBidi: 'isolate',
        fontFamily: 'Times New Roman, serif',
        color: '#000'
      }}>
        Page not found
      </h1>
      <p style={{ 
        display: 'block',
        marginBlockStart: '1em',
        marginBlockEnd: '1em',
        marginInlineStart: '0px',
        marginInlineEnd: '0px',
        unicodeBidi: 'isolate',
        fontSize: '16px',
        fontFamily: 'Times New Roman, serif'
      }}>
        The requested page could not be found.
      </p>
    </div>
  );
}


export default ExtraErrorOutside;